// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1riTf","title":"styles_title__1_JHH","content":"styles_content__38CCD","collapsed":"styles_collapsed__1bSEY"};